import React from "react";
import { useNavigate } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

export default function Carrusel() {
  const navigate = useNavigate();

  const irACategoria = (categoria) => {
    const categoriaURL = encodeURIComponent(categoria);
    navigate(`/catalogo?categoria=${categoriaURL}`);
  };

  return (
    <div className="w-full min-h-[300px] sm:min-h-[400px] md:min-h-[500px] lg:min-h-[600px] aspect-[16/9] relative rounded-xl overflow-hidden">
      <Carousel
        autoPlay
        infiniteLoop
        showThumbs={false}
        showStatus={false}
        interval={4000}
        transitionTime={800}
        className="w-full h-full"
      >
        {/* Slide 1 - Cafetería */}
        <div
          onClick={() => irACategoria("cafeteria")}
          className="cursor-pointer pointer-events-auto relative"
        >
          <img
            src="https://i.imgur.com/b3f991P.png"
            alt="Cafetería"
            className="w-full h-full object-cover pointer-events-none"
          />
          <div className="absolute bottom-4 left-4 bg-black/60 text-white px-4 py-2 rounded-lg text-lg font-semibold">
            Cafetería
          </div>
        </div>

        {/* Slide 2 - Limpieza */}
        <div
          onClick={() => irACategoria("limpieza")}
          className="cursor-pointer pointer-events-auto relative"
        >
          <img
            src="https://i.imgur.com/dhf6pzb.png"
            alt="Limpieza"
            className="w-full h-full object-cover pointer-events-none"
          />
          <div className="absolute bottom-4 left-4 bg-black/60 text-white px-4 py-2 rounded-lg text-lg font-semibold">
            Limpieza
          </div>
        </div>

        {/* Slide 3 - Protección Personal */}
        <div
          onClick={() => irACategoria("proteccion personal")}
          className="cursor-pointer pointer-events-auto relative"
        >
          <img
            src="https://i.imgur.com/cMDIDyl.png"
            alt="Protección Personal"
            className="w-full h-full object-cover pointer-events-none"
          />
          <div className="absolute bottom-4 left-4 bg-black/60 text-white px-4 py-2 rounded-lg text-lg font-semibold">
            Protección Personal
          </div>
        </div>

        {/* Slide 4 - Kimberly Clark */}
        <div
          onClick={() => irACategoria("linea institucional")}
          className="cursor-pointer pointer-events-auto relative"
        >
          <img
            src="https://i.imgur.com/CAI387c.png"
            alt="linea institucional"
            className="w-full h-full object-cover pointer-events-none"
          />
          <div className="absolute bottom-4 left-4 bg-black/60 text-white px-4 py-2 rounded-lg text-lg font-semibold">
            Kimberly Clark
          </div>
        </div>
      </Carousel>
    </div>
  );
}
